//Models
PJQ.models.productionQuantities.ProductionQuantity = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'productionquantities',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;


        this.installedQuantities = new PJQ.collections.productionQuantities.InstalledQuantities(model.installedQuantities);

        return model;
    },
    beforeSave: function () {
        this.set({
            installedQuantities: this.installedQuantities.toJSON()
        });
    }
});

PJQ.models.productionQuantities.InstalledQuantity = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

//Collections
PJQ.collections.productionQuantities.ProductionQuantities = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.productionQuantities.ProductionQuantity,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'productionquantities'
            }
        ]);
    },
    saveBulk: function(productionQuantities, callback) {
        let endpoint = `${this.endpoint()}/bulk`;

        new PJQ.ajax.Request({
            endpoint: endpoint,
            isAPIv2: true,
            data: productionQuantities
        }).post().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    }
});

PJQ.collections.productionQuantities.InstalledQuantities = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.productionQuantities.InstalledQuantity,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'productionquantities',
                value: this.options.productionQuantityId
            },
            {
                endpoint: 'installed'
            }
        ], params);
    },
    saveBulk: function(installedQuantities, callback) {
        let endpoint = `${this.endpoint()}/bulk`;

        new PJQ.ajax.Request({
            endpoint: endpoint,
            isAPIv2: true,
            data: installedQuantities
        }).post().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    }
});